/* ==========================================================================
   OD Bakım rehberi: üç adımlı hesaplayıcı (ürün → konu → çözüm)
   Veri bölümdeki <script data-cr-data> JSON'undan okunur; DOM yalnızca createElement/textContent ile kurulur.
   ========================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function init(root) {
    if (root.__cr) return;
    root.__cr = true;
    var raw = root.querySelector('[data-cr-data]');
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw.textContent); } catch (e) { return; }
    var icons = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-cr-icons] template'), function (t) { icons[t.getAttribute('data-icon')] = t; });

    var stage = root.querySelector('[data-cr-stage]');
    var panels = { g: root.querySelector('[data-cr-panel="g"]'), c: root.querySelector('[data-cr-panel="c"]'), s: root.querySelector('[data-cr-panel="s"]'), r: root.querySelector('[data-cr-panel="r"]') };
    var back = root.querySelector('[data-cr-back]'), reset = root.querySelector('[data-cr-reset]');
    var track = Array.prototype.slice.call(root.querySelectorAll('[data-cr-track]'));
    var state = { g: null, c: null, s: null };
    var history = [];

    function solutionsFor(g, c) {
      return data.solutions.filter(function (s) {
        var gs = (s.g || '').split(',').map(function (x) { return x.trim(); });
        return s.c === c && (gs.indexOf('tumu') > -1 || gs.indexOf(g) > -1);
      });
    }
    function challengesFor(g) {
      return data.challenges.filter(function (c) { return solutionsFor(g, c.key).length; });
    }

    function option(label, iconKey, onPick) {
      var li = el('li');
      var b = el('button', 'cr-opt');
      b.type = 'button';
      if (iconKey && icons[iconKey]) b.appendChild(icons[iconKey].content.cloneNode(true));
      b.appendChild(el('span', 'cr-opt__l', label));
      b.addEventListener('click', onPick);
      li.appendChild(b);
      return li;
    }
    function fillOptions(key, items) {
      var ul = root.querySelector('[data-cr-opts="' + key + '"]');
      ul.textContent = '';
      items.forEach(function (i) { ul.appendChild(option(i.label, i.icon, i.pick)); });
    }
    function show(which) {
      Object.keys(panels).forEach(function (k) { panels[k].hidden = k !== which; });
      var stepNo = which === 'g' ? 1 : (which === 'c' || which === 's') ? 2 : 3;
      track.forEach(function (t, i) {
        t.classList.toggle('is-on', i + 1 === stepNo);
        t.classList.toggle('is-done', i + 1 < stepNo);
      });
      back.hidden = which === 'g';
      reset.hidden = which === 'g';
      stage.focus({ preventScroll: true });
    }
    function go(which) {
      history.push(which);
      show(which);
    }

    function stepG() {
      state = { g: null, c: state.c, s: null };
      fillOptions('g', data.garments.map(function (g) {
        return { label: g.label, icon: g.key, pick: function () { state.g = g.key; state.c ? afterC() : stepC(); } };
      }));
      go('g');
    }
    function stepC() {
      var list = challengesFor(state.g);
      fillOptions('c', list.map(function (c) {
        return { label: c.label, icon: c.key, pick: function () { state.c = c.key; afterC(); } };
      }));
      go('c');
    }
    function afterC() {
      var sols = solutionsFor(state.g, state.c);
      if (!sols.length) return result(null);
      if (state.c === 'leke' && sols.length > 1) {
        fillOptions('s', sols.map(function (s) {
          return { label: s.stain || s.title, icon: 'leke', pick: function () { result(s); } };
        }));
        return go('s');
      }
      result(sols[0]);
    }
    function result(sol) {
      var title = panels.r.querySelector('[data-cr-title]'), ol = panels.r.querySelector('[data-cr-steps]');
      var tip = panels.r.querySelector('[data-cr-tip]'), none = panels.r.querySelector('[data-cr-none]');
      ol.textContent = '';
      if (!sol) {
        title.textContent = '';
        none.hidden = false;
        tip.hidden = true;
      } else {
        none.hidden = true;
        title.textContent = sol.title || '';
        (sol.steps || '').split(/\r?\n/).forEach(function (line) {
          line = line.trim();
          if (line) ol.appendChild(el('li', null, line));
        });
        tip.hidden = !sol.tip;
        tip.textContent = sol.tip || '';
      }
      go('r');
      if (!reduce) panels.r.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'cubic-bezier(.22,.7,.18,1)' });
    }

    back.addEventListener('click', function () {
      history.pop();
      var prev = history.pop();
      if (!prev) { state = { g: null, c: null, s: null }; return stepG(); }
      if (prev === 'g') { state.c = presetTopic; return stepG(); }
      if (prev === 'c') return stepC();
      if (prev === 's') return afterC();
      stepG();
    });
    reset.addEventListener('click', function () { history = []; presetTopic = null; state = { g: null, c: null, s: null }; stepG(); });

    // konu kartı veya adresten gelen ön seçim
    var presetTopic = null;
    function preset(topic) {
      presetTopic = topic;
      history = [];
      state = { g: null, c: topic, s: null };
      stepG();
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-cr-topic]');
      if (!a) return;
      preset(a.getAttribute('data-cr-topic'));
    });

    var q = new URLSearchParams(window.location.search);
    var g0 = q.get('giysi'), c0 = q.get('konu');
    if (g0 && data.garments.some(function (g) { return g.key === g0; })) {
      history = [];
      state = { g: g0, c: c0, s: null };
      if (c0) afterC(); else stepC();
    } else {
      stepG();
    }
  }

  function boot() { document.querySelectorAll('[data-od-careculator]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
